import React, { useEffect, useState } from "react";
import PostingList from "./PostingList";
import { t } from "../i18n";
import "./Posts.css";
import TrendingGames from "./TrendingGames";
import styles from "./TrendingGames.module.css";
import SortBy from "./SortBy";
import { useUser } from "../context/UserAttrContext";
import { getSessionUserId } from "../utils/auth";
import { usePostsFeed } from "../hooks/usePostsFeed";

const Posts = ({ doRefreshPosts, appRefresh }) => {
  const { user } = useUser();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 750);
  const [visibleCount, setVisibleCount] = useState(22);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [filter1, setFilter1] = useState("");
  const [filter2, setFilter2] = useState("");
  const [filter3, setFilter3] = useState("");
  const [filter4, setFilter4] = useState("");

  const {
    error,
    favoriteGameNames,
    friendPosts,
    isLoaded,
    loadPosts,
    posts,
  } = usePostsFeed({
    currentUserId: getSessionUserId(),
    favoriteGameIds: user.favoriteGames || [],
    filter4,
  });

  const clearFilters = () => {
    setFilter1("");
    setFilter2("");
    setFilter3("");
  };

  const filteredPosts = posts.filter((post) => {
    const tags = post.attributes?.tags || [];
    const title = post.title?.toLowerCase() || "";
    const body = post.body?.toLowerCase() || "";
    const username = post.author?.attributes?.username?.toLowerCase() || "";

    const textMatch =
      !filter1 ||
      title.includes(filter1.toLowerCase()) ||
      body.includes(filter1.toLowerCase()) ||
      username.includes(filter1.toLowerCase());

    const filter2Match = !filter2 || tags.includes(filter2);
    const filter3Match = !filter3 || tags.includes(filter3);

    const filter4Match =
      filter4 === "Friends"
        ? friendPosts.some((friendPost) => friendPost.id === post.id)
        : filter4 === "Favorite Games"
          ? favoriteGameNames.some((gameName) =>
              tags.some((tag) => tag?.toLowerCase() === gameName?.toLowerCase())
            )
          : true;

    return textMatch && filter2Match && filter3Match && filter4Match;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 750);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) return;

    const handleScroll = () => {
      if (
        !isLoadingMore &&
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 50 &&
        visibleCount < filteredPosts.length
      ) {
        setIsLoadingMore(true);
        setTimeout(() => {
          setVisibleCount(prev => Math.min(prev + 15, filteredPosts.length));
          setIsLoadingMore(false);
        }, 1000);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [filteredPosts.length, isMobile, isLoadingMore, visibleCount]);

  return (
    <div>
      {isMobile ? (
        <div className="mobile-content-wrapper">
          <div className="mobile-posts-section">
            <SortBy
              filter1={filter1}
              setFilter1={setFilter1}
              filter2={filter2}
              setFilter2={setFilter2}
              filter3={filter3}
              setFilter3={setFilter3}
              filter4={filter4}
              setFilter4={setFilter4}
              clearFilters={clearFilters}
              isMobile={isMobile}
            />
            <div className="posts-container">
              {filter4 === "Friends" && !isLoaded && <div>{t("loading_posts")}</div>}
              {filter4 === "Friends" && isLoaded && friendPosts.length === 0 && <div>{t("no_posts_found")}</div>}
              <PostingList
                refresh={appRefresh}
                posts={filteredPosts}
                error={error}
                isLoaded={isLoaded}
                type="postlist"
                loadPosts={loadPosts}
              />
            </div>
          </div>
          <TrendingGames />
        </div>
      ) : (
        <div className="content-wrapper">
          <div className="left-section">
            <SortBy
              filter1={filter1}
              setFilter1={setFilter1}
              filter2={filter2}
              setFilter2={setFilter2}
              filter3={filter3}
              setFilter3={setFilter3}
              filter4={filter4}
              setFilter4={setFilter4}
              clearFilters={clearFilters}
              isMobile={isMobile}
            />

            <div className="posts-container">
              {filter4 === "Friends" && !isLoaded && <div>{t("loading_posts")}</div>}
              {filter4 === "Friends" && isLoaded && friendPosts.length === 0 && <div>{t("no_posts_found")}</div>}
              <PostingList
                refresh={appRefresh}
                posts={filteredPosts.slice(0, visibleCount)}
                error={error}
                isLoaded={isLoaded}
                type="postlist"
                loadPosts={loadPosts}
              />
              {isLoadingMore && (
                <div className="loading-spinner">{t("loading_more_posts")}</div>
              )}
            </div>
          </div>
          <div className={styles.trendingGamesWrapper}>
            <TrendingGames />
          </div>
        </div>
      )}
    </div>
  );
};

export default Posts;
